'use client';

import { storyblokEditable } from '@storyblok/react/rsc';
import clsx from 'clsx';

import { HeadingMarkdown } from '../HeadingMarkdown/HeadingMarkdown';

import { RichText, Typography } from '@/components/core';
import { ImageBlockServer } from '@/components/core/Image/ImageBlock';

import { HeaderSectionStoryblok } from '@/types/storyblok/storyblok-types';
import styles from './HeaderSection.module.scss';

type HeaderSectionProps = {
    blok: HeaderSectionStoryblok;
};

// export const HeaderSection: React.FC<HeaderSectionProps> = async ({ blok }) => {
export const HeaderSection: React.FC<HeaderSectionProps> = ({ blok }) => (
    <div
        className={clsx('sectionVerticalPadding', styles.root)}
        {...storyblokEditable(blok)}
    >
        <div
            className={clsx(styles.wrapper, {
                [styles.noImage]: !blok?.image?.filename,
            })}
        >
            {blok.pretitle && <Typography className={clsx('subheader', styles.pretitle)}>{blok.pretitle}</Typography>}
            <HeadingMarkdown>{blok.title}</HeadingMarkdown>
            {blok.description && (
                <div className={styles.descriptionWrapper}>
                    <RichText
                        classNameRoot={(styles.description, 'p')}
                        document={blok.description}
                    />
                </div>
            )}
            {/* {blok.showButton && (
                    <Suspense fallback={<Button className={styles.button}>{translations.contact}</Button>}>
                        <ContactButton
                            className={styles.button}
                            title={translations.contact}
                        />
                    </Suspense>
                )} */}
        </div>

        {blok?.image?.filename && (
            <ImageBlockServer
                className={styles.image}
                width={486}
                height={560}
                src={blok.image.filename}
                alt={blok.image?.alt}
                focalPoints={blok.image.focus}
                priority
                jsonData={{
                    images: [
                        {
                            contentUrl: blok.image?.filename,
                            copyrightNotice: blok.image?.copyright,
                        },
                    ],
                }}
            />
        )}
    </div>
);
